/// <summary>
/// This object is a generalization of the vcTemplate to send an Email <br/>
/// It is basically an extraction from the SendEmail Widget in the Intervention
/// Author: MWI/AFU<br />
/// Date: 1.12.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 12.02.2016                                               *<br />
/// **********************************************************************<br />
/// * -  added bcc loading and some small style tests                    *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 1.12.2015                                               *<br />
/// **********************************************************************<br />
/// * -  inherited from template.js and the SendEmail widget             *<br />
/// **********************************************************************<br />
/// </summary>

function sendEmail() { }
sendEmail.prototype = new vcTemplate();


sendEmail.prototype.init = function () {
    ///<summary>
    ///initializes the object by loading the editor <br/>
    /// creating the various event handlers and the dropdowns 
    ///</summary>
    var me = this;
    try {
        me.showInfo("", "", false);
        //init the content editor
        me.visual.find('#txtBody').cleditor({
            height: 270, width: "auto",
            controls: "bold italic underline | font size style removeformat | bullets numbering | outdent  indent | alignleft center alignright justify | undo redo | rule link unlink | cut copy paste pastetext "
        });
        //'init the chosen multiselect dropdown
        me.visual.find('#ddlTo,#ddlToBCC').chosen({ placeholder_text_multiple: me.resources.selectRecipientsGendered, search_contains:true, inherit_select_classes:true, width:"100%" });

        //'validate input fields on every keyup
        me.visual.find('#txtSubject').off('keyup').on('keyup', function () { me.validateSubject(); });
        me.visual.find('#txtTo, #txtToBCC').off('keyup').on('keyup', function () { me.validateEmail(false); });
        me.visual.find('#ddlTo').off('change').on('change', function () { me.validateEmail(false); });
        //'init the send button event
        me.visual.find('#btnSend').button().off('click').on('click', function () {
            var obj = {};
            if (me.validateEmail(false) === false || me.validateSubject() === false) {
                return false; }

            me.showMessage(me.resources.emailSending, false);

            obj.subject = me.visual.find('#txtSubject').val();
            obj.body = me.visual.find('#txtBody').val();
            obj.receipients = me.visual.find('#ddlTo').val();
            obj.external = me.visual.find('#txtTo').val();
            obj.bccReceipients = me.visual.find("#ddlToBCC").val();
            obj.bccExternal = me.visual.find("#txtToBCC").val();
            obj.sendAttachment = me.visual.find('#chkAttachment').prop('checked');
            obj.attachmentType = 2;
            obj.attachmentId = me.attachmentId;
            window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, me.param, me.sigPar, 1, 2, JSON.stringify(obj),
           function (result) {
               if (result === null) { me.showMessage('', true); return false; }
               if (result === false) {
                   me.showInfo(me.resources.errNotSent, "", true);
               } else {
                   me.showInfo(me.resources.successSent,"", false);
               }
               me.visual.find('#btnSend').button('disable');
               return true;
           });
            return false;
        });
        me.validateEmail(true);

        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};

sendEmail.prototype.validateSubject = function () {
    ///<summary>
    ///Ensures that the Subject is not Empty
    ///</summary>
    var me = this;
    try {
        if (me.visual.find('#txtSubject').val().length === 0) {
            $(this).removeClass('formItemValid').addClass('formItemInvalid');
            me.showInfo(me.resources.errAddSubject, "", true);
            me.visual.find('#btnSend').button('disable');
            return false;
        } else {
            me.visual.find('#txtSubject').removeClass('formItemInvalid').addClass('formItemValid');
            me.visual.find('#divInfo').hide();
            me.visual.find('#btnSend').button('enable');
            return true;
        }
    } catch (ex) { me.writeError('validateSubject', ex); return false; }
};


sendEmail.prototype.validateEmail = function (bFirstCall) {
    ///<summary>this function validates the email addresses <br/>
    ///at least one user or one manual/external address must exist</summary>
    var me = this;
    var bEmpty = false;
    try {

        if (typeof(me.visual.find('#txtTo').val()) === 'undefined') {
            bEmpty = true;
        } else {
        if (me.visual.find('#txtTo').val().trim().length === 0 && me.visual.find('#ddlTo').val() === null) {
            bEmpty = true;
            }
        }
        if (bEmpty) {
            if (!bFirstCall) {
                me.visual.find('#txtTo,#ddlTo').removeClass('formItemValid').addClass('formItemInvalid');
            }
             me.showInfo(me.resources.errOneRcpt, "", true);
            me.visual.find('#btnSend').button('disable');
            return false;
        } else {
            //'validate if the manual addresses got separated by ';'
            if (me.visual.find('#txtTo').val().indexOf(';') > -1) {
                me.visual.find('#txtTo,#ddlTo').removeClass('formItemValid').addClass('formItemInvalid');
                me.showInfo(me.resources.multiSep, "", true);
                me.visual.find('#btnSend').button('disable');
                return false;
            } else if (me.visual.find('[type="email"]').length > 0 && me.visual.find('#txtTo:invalid, #txtToBCC:invalid').length > 0) {
                //if it is a newer browser use the included html5 email test to verify a valid email
                me.visual.find('#txtTo,#txtToBCC').removeClass('formItemValid').addClass('formItemInvalid');
                    me.showInfo(me.resources.emailInvalid, "", true);
                    me.visual.find('#btnSend').button('disable');
                    return false;
            } else {
                me.visual.find('#txtTo,#ddlTo').removeClass('formItemInvalid').addClass('formItemValid');
                me.showInfo("", "", false);
                me.visual.find('#btnSend').button('enable');
                return true;
            }
        }
    } catch (ex) { me.writeError('sendEmail.validateEmail', ex); return false; }
};